<template>
    <div class="visitor-history-page">
        <div class="header mb-2">{{ visitorName }}</div>
        <div class="visitor-history">
            <visitor-attendance ref="visitorAttendance"/>
            <visitor-activity ref="visitorActivity"/>
        </div>
    </div>
</template>

<script>
import VisitorAttendance from '@/components/Visitor/VisitorAttendance'
import VisitorActivity from '@/components/Visitor/VisitorActivity'

export default {
    name: 'VisitorHistory',

    components: {
        VisitorAttendance,
        VisitorActivity
    },

    data () {
        return {
            visitorId: '',
            visitorName: ''
        }
    },

    methods: {
        async getVisitorInfo (id) {
            const url = `visitor/${id}`
            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                const data = res.data.data
                this.visitorName = `${data.name} ${data.surname}`
            }
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        this.visitorId = this.$route.params.id
        await this.$refs.visitorActivity.getActivityLog()
        await this.getVisitorInfo(this.visitorId)
        await this.$refs.visitorAttendance.getVisitorAttendance(this.visitorId)
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style lang="scss" scoped>
    .visitor-history-page {
        height: 85vh;
        padding-bottom: 2rem;
        .visitor-history {
            display: grid;
            grid-template-columns: 50% 50%;
            grid-gap: 25px;
            height: 100%;

            .visitor-log {
                width: 100%;
                padding: 2rem;
            }
        }
    }

    .select-sort {
        width: 40%;
    }
</style>
